<template>
  <div class="homepage">
    <div class="page page--landing">
      <router-link to="/transport" class="page-block page-block--main" style="background-color: #2b6eac">
        <div class="page-block__icon"><img src="@/assets/icons/bus.svg" alt=""></div>
        <div class="page-block__heading">Transport</div>
      </router-link>
      <router-link to="/whats-on" class="page-block page-block--main" style="background-color: #598D16">
        <div class="page-block__icon"><img src="@/assets/icons/map.svg" alt=""></div>
        <div class="page-block__heading">What's On</div>
      </router-link>
      <a href="https://www.manurewabusiness.co.nz/win/" class="page-block page-block--main" style="background-color: #dd9e2c">
        <div class="page-block__icon"><img src="@/assets/icons/voucher.svg" alt=""></div>
        <div class="page-block__heading page-block__heading--long">Get Discounts and Competitions</div>
      </a>
      <router-link to="/store-directory" class="page-block page-block--main" style="background-color: #894cbe">
        <div class="page-block__icon"><img src="@/assets/icons/milford.svg" alt=""></div>
        <div class="page-block__heading page-block__heading--long">Store Directory and Emergency Numbers</div>
      </router-link>
      <router-link to="/whats-on/our-community" class="page-block page-block--main" style="background-color: #894cbe">
        <div class="page-block__icon"><img src="@/assets/icons/people.svg" alt=""></div>
        <div class="page-block__heading page-block__heading--long">Our Community</div>
      </router-link>
      <router-link to="/facebook-links" class="page-block page-block--main" style="background-color: #894cbe">
        <div class="page-block__icon"><img src="@/assets/icons/facebook.svg" alt=""></div>
        <div class="page-block__heading page-block__heading--long">Facebook Links</div>
      </router-link>
      <router-link to="/have-your-say" class="page-block page-block--main" style="background-color: #1c87d2">
        <div class="page-block__icon"><img src="@/assets/icons/speech.svg" alt=""></div>
        <div class="page-block__heading">Have Your SAY!</div>
      </router-link>
      <router-link to="/jobs" class="page-block page-block--main" style="background-color: #4f66cd">
        <div class="page-block__icon"><img src="@/assets/icons/suitcase.svg" alt=""></div>
        <div class="page-block__heading">Local Jobs</div>
      </router-link>
    </div>
    <weather-widget></weather-widget>
  </div>
</template>

<script>
import { getCache, setCache } from "@/services/cache";
import WeatherWidget from "@/components/WeatherWidget.vue";

const OPENWEATHER_HOST = 'https://api.openweathermap.org';
const ONE_CALL_API = `${OPENWEATHER_HOST}/data/2.5/onecall`;
const API_KEY = 'e727b72a36203da805bf1ce55c36d074';


export default {
  components: {
    WeatherWidget,
  },
  data: function () {
    return {
      forecast: [],
      isiOs: false
    }
  },
  async mounted() {
    this.getDeviceType();

    const cache = getCache('forecast');
    if (cache !== null) {
      this.forecast = cache;
    }
    else {
      this.forecast = await this.getForecastByCoordinates({lat: -37.0210, lon: 174.8958});
      setCache('forecast', this.forecast, 10);
    }

  },
  methods: {
    getOSType() {
      if (/(Android)/i.test(navigator.userAgent)) {
        return 'Android'
      } else if (/(iPhone|iPad|iPod|iOS|Macintosh)/i.test(navigator.userAgent)) {
        return 'iOS'
      }
    },
    getDeviceType() {
      let osType = this.getOSType()
      if (osType === 'iOS') {
        this.isiOS = true
      }
    },
    async getForecastByCoordinates(coordinates) {
      const apiEndpoint = new URL(ONE_CALL_API);
      const params = {
        lat: coordinates.lat,
        lon: coordinates.lon,
        units: 'metric',
        appid: API_KEY
      };
      apiEndpoint.search = new URLSearchParams(params).toString();

      return fetch(apiEndpoint.href,{
        method: 'get',
      })
          .then(response => response.json())
          .then(result => {
            return result.daily.slice(0, 3);
          })
    },
    timestampToDay(timestamp) {
      const index = new Date(timestamp * 1000).getDay();
      const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      return days[index];
    },
    timestampToDate(timestamp) {
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      const dateTime = new Date(timestamp * 1000);
      return `${dateTime.getDate()} / ${months[dateTime.getMonth()]}`;
    }
  }
}
</script>
